"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A Config object that contains the Discovery Server response
 * parsed into an object that can be read.
 */
var dot_object_1 = __importDefault(require("dot-object"));
var DiscoveryConfig = /** @class */ (function () {
    function DiscoveryConfig(config) {
        this.plugins = {};
        this.config = config;
    }
    /**
     * Sets the Site section of the config.
     * @param name
     * @param abbrName
     * @param organization {string}
     * @param description
     */
    DiscoveryConfig.prototype.setSite = function (name, abbrName, organization, description) {
        this.site = {
            name: name,
            abbrName: abbrName,
            organization: organization,
            description: description
        };
    };
    /**
     *  Set the Contact section of the config
     * @param name
     * @param email
     * @param tel
     */
    DiscoveryConfig.prototype.setContact = function (name, email, tel) {
        this.contact = {
            name: name,
            email: email,
            tel: tel
        };
    };
    /**
     * Set the address URL section of the config
     * @param api
     * @param status
     * @param analytics
     */
    DiscoveryConfig.prototype.setAddresses = function (api, status, analytics) {
        this.addresses = {
            api: api,
            status: status,
            analytics: analytics
        };
    };
    /**
     * Set the URL's for the assets.
     * @param logo
     * @param logoAuth {string}
     */
    DiscoveryConfig.prototype.setAssetUrls = function (logo, logoAuth) {
        this.assets = {
            logo: logo,
            logoAuth: logoAuth
        };
    };
    /**
     * Add a new plugin to the config array
     * @param key {string} The identifier of the plugin
     * @param data {DiscoveryConfigPluginNode} The data for the plugin
     */
    DiscoveryConfig.prototype.addPlugin = function (key, data) {
        this.plugins[key] = data;
    };
    /**
     * Get the name of the site contact.
     * @returns {string}
     */
    DiscoveryConfig.prototype.getContactName = function () {
        return this.contact.name;
    };
    /**
     *  Get the email address of the site contact.
     *  @returns {string}
     */
    DiscoveryConfig.prototype.getContactEmail = function () {
        return this.contact.email;
    };
    /**
     * Get the telephone of the site contact.
     * @returns {string|null}
     */
    DiscoveryConfig.prototype.getContactTel = function () {
        return this.contact.tel;
    };
    /**
     * Check to see if the contact has a telephone.
     * @returns {boolean}
     */
    DiscoveryConfig.prototype.hasContactTel = function () {
        return this.contact.tel != null;
    };
    /**
     * Get the name of the site.
     * @returns {string}
     */
    DiscoveryConfig.prototype.getSiteName = function () {
        return this.site.name;
    };
    /**
     * Get the abbreviated name of the site.
     * @returns {string}
     */
    DiscoveryConfig.prototype.getSiteAbbrName = function () {
        return this.site.abbrName;
    };
    /**
     * Get a description of the site.
     * @returns {string}
     */
    DiscoveryConfig.prototype.getSiteDescription = function () {
        return this.site.description;
    };
    /**
     * Get the organization name of the site.
     * @returns {string}
     */
    DiscoveryConfig.prototype.getSiteOrganization = function () {
        return this.site.organization;
    };
    /**
     * Get the address of API backend server.
     * @returns {string}
     */
    DiscoveryConfig.prototype.getApiAddress = function () {
        return this.addresses.api;
    };
    /**
     * Get the address of the status monitoring server.
     * @returns {string|null}
     */
    DiscoveryConfig.prototype.getStatusAddress = function () {
        return this.addresses.status;
    };
    /**
     * Get the full address of the analytics post server.
     * @returns {string|null}
     */
    DiscoveryConfig.prototype.getAnalyticsAddress = function () {
        return this.addresses.analytics;
    };
    /**
     * Get the address of the logo
     * @returns {string}
     */
    DiscoveryConfig.prototype.getLogoUrl = function () {
        return this.assets.logo;
    };
    /**
     * Get the address of the logo
     * @returns {string}
     */
    DiscoveryConfig.prototype.getLogoAuthUrl = function () {
        return this.assets.logoAuth;
    };
    /**
     * Gets any available plugin registered for this application
     */
    DiscoveryConfig.prototype.getPlugins = function () {
        return this.plugins;
    };
    DiscoveryConfig.prototype.getByKey = function (key) {
        return dot_object_1.default.pick(key, this.config);
    };
    return DiscoveryConfig;
}());
exports.DiscoveryConfig = DiscoveryConfig;
//# sourceMappingURL=data:application/json;base64,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